module.exports = __webpack_public_path__ + "img/yhq.87c4b580.png";